export default __webpack_public_path__ + "static/media/logo-atgen-blanco.9ae3d198.png";